import React from 'react';

import {DOWNLOADS_PLACEHOLDER_ID} from 'src/modules/downloads/constants';

export const DownloadButtonPlaceholder = React.memo(() => {
    return (
        <div id={DOWNLOADS_PLACEHOLDER_ID}/>
    );
}, () => true);
